import { render, staticRenderFns } from "./KoioteFooter.vue?vue&type=template&id=586557c4&lang=true&"
import script from "./KoioteFooter.vue?vue&type=script&lang=js&"
export * from "./KoioteFooter.vue?vue&type=script&lang=js&"
import style0 from "./KoioteFooter.vue?vue&type=style&index=0&id=586557c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports